/**
 * The render outcome the BFF decides for the public Receipt Lookup portal.
 * Mirrors the backend ReceiptPortalContextStatus enum.
 */
export const ReceiptPortalStatus = {
  Unavailable: "Unavailable",
  Available: "Available",
};

/**
 * Resolves the public Receipt Lookup portal context from the aggregated BFF endpoint.
 * The BFF decides the outcome (status) and returns the display name and LPR flag only
 * when the status is Available. The endpoint is reachable with the public MobilePay token.
 */
class ReceiptPortalService {
  constructor(client) {
    this.apiClient = client;
  }

  /**
   * Fetches the portal context for an entity.
   *
   * @param {string} entityId The facility or facility-group id from the URL.
   * @returns {Promise<{ status: string, name: (string|undefined), lprEnabled: boolean }>}
   *   The resolved context. On a request error, resolves to a NotFound fallback so the
   *   page shows the not-found message rather than breaking.
   */
  async getContext(entityId) {
    try {
      const response = await this.apiClient.get(
        `receipt-portal/${entityId}/context`
      );
      const data = response?.data ?? {};
      return {
        status: data.status ?? data.Status ?? ReceiptPortalStatus.Unavailable,
        name: data.name ?? data.Name,
        lprEnabled: (data.lprEnabled ?? data.LprEnabled) === true,
      };
    } catch (error) {
      return {
        status: ReceiptPortalStatus.Unavailable,
        name: undefined,
        lprEnabled: false,
      };
    }
  }
}

export default ReceiptPortalService;
